"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepCheckWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StepCheckWrapper = exports.StepCheckWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__StepCheckWrapper",
  componentId: "sc-14imc34-0"
})(["display:flex;flex-direction:column;background:", ";position:relative;"], _palette.commonPalette.white);
//# sourceMappingURL=styles.js.map